import React, { useEffect, useLayoutEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import {
  iframeService,
  isMobile,
  notificationStore,
  NumPad,
  useTranslation,
} from '@pascal/pascal-core';
import { useInputValueChangingFunctions } from '@pascal/pascal-core/shared/hooks/useInputValueChangingFunctions';
import { InputTypesForChanging } from '@pascal/pascal-core/shared/core/enums/additionalInputValueChangingButtons';
import { gameConfigStore, userInfoStore } from '@pascal/pascal-core/shared/core/store';
import { freeBetStore } from '@pascal/pascal-core/shared/core/store/freeBetStore';
import { useClickOutside } from '../../../../hooks';
import BetSection from './betSection';
import { doBetStore, gameStore } from '../../../../store';
import { NumPadWr } from '../../../../containers/mobile/numPadWr/numPad';
import { betAmountValidator, changeBetAmount } from '../../../../helpers/supporters';

let mobileWrRef;

const GameMainBottom = observer(() => {
  const { balance, currencySymbolOrCode } = userInfoStore;
  const { limits } = gameConfigStore;
  const { isOpen } = gameStore.numPadData;
  const { activeFreeBet } = freeBetStore;
  const { handleChangeInputValue } = useInputValueChangingFunctions({
    dividerOrMultiplayer: 2,
    changingValue: doBetStore.betData.amount,
    changingValueCallback: doBetStore.setBetAmount,
    additionalInputInfo: { inputType: InputTypesForChanging.BetInput },
  });
  const {
    betData: { amount, range, isDisabled },
    autoBetData,
    currentWinOdd,
    setCurrentWinOdd,
  } = doBetStore;

  const [namPudInputValue, updateNumPudInputValue] = useState(limits.minBet);
  const [ref, hasClickedOutside] = useClickOutside();
  const t = useTranslation();

  const handleInputBlur = (betAmount) => betAmountValidator(betAmount, gameConfigStore.limits);

  useLayoutEffect(() => {
    mobileWrRef = document.querySelector('.mobile-wr');
  }, []);

  useEffect(() => {
    if (hasClickedOutside) {
      gameStore.setNumPadData({ isOpen: false, currentInputValue: null });
    }
  }, [hasClickedOutside]);

  const validatedNumPudInputValue = (callback) => {
    const { validatedBetAmount, errorMessageCode } = handleInputBlur(namPudInputValue);
    if (errorMessageCode) {
      notificationStore.setNotificationType({ responseCode: errorMessageCode });
    }
    iframeService.sendStakeUpdate(validatedBetAmount);
    callback(validatedBetAmount);
  };

  const handleSubmit = (isConfirmed) => {
    if (isConfirmed) {
      validatedNumPudInputValue(doBetStore.setBetAmount);
      gameStore.setNumPadData({ isOpen: false, sectionName: null, currentInputValue: null });
    }
  };

  const handleOpenNumPad = (event) => {
    if (isMobile()) {
      updateNumPudInputValue(event.target.value);
      gameStore.setNumPadData({
        isOpen: true,
        currentInputValue: event.target.value,
      });
    }
  };

  const changeBetInputValue = (functionName) => {
    changeBetAmount(
      functionName,
      doBetStore.setBetAmount,
      gameConfigStore.limits,
      balance,
      amount,
      notificationStore.setNotificationType
    );
  };

  return (
    <>
      <BetSection
        t={t}
        minOdd={1}
        maxOdd={100}
        range={range}
        balance={balance}
        limits={limits}
        betAmount={amount}
        currentWinOdd={currentWinOdd}
        autoBetData={autoBetData}
        setRange={doBetStore.setRange}
        handleOpenNumPad={handleOpenNumPad}
        currencySymbol={currencySymbolOrCode}
        onBlur={handleInputBlur}
        handleChangeInputValue={handleChangeInputValue}
        setCurrentWinOdd={setCurrentWinOdd}
        activeFreeBet={activeFreeBet}
        changeBetInputValue={changeBetInputValue}
        onChange={doBetStore.setBetAmount}
        showNotification={notificationStore.setNotificationType}
        isDisabledBetSection={isDisabled}
      />
      <NumPadWr containerRef={mobileWrRef}>
        <div ref={ref} className='numpad-wr-for-outside-click'>
          <NumPad
            t={t}
            isOpen={isOpen}
            limits={limits}
            onSubmit={handleSubmit}
            amountValue={namPudInputValue}
            setAmountValue={updateNumPudInputValue}
          />
        </div>
      </NumPadWr>
    </>
  );
});

export default GameMainBottom;
